module.exports = __webpack_public_path__ + "static/media/people-icon.3e03f5f5.svg";